import { AxiosRequestConfig } from "axios";

export type RequestConfig = AxiosRequestConfig;

export class ApiConfiguration {
  baseUrl: string;

  contentType: string;

  getAccessToken?: () => string | undefined;

  getHeaderTenantIdCode?: () => string | undefined;
}

export interface IApiClient {
  post<TRequest, TResponse>(
    path: string,
    object: TRequest,
    config?: RequestConfig
  ): Promise<TResponse>;
  patch<TRequest, TResponse>(path: string, object: TRequest): Promise<TResponse>;
  put<TRequest, TResponse>(path: string, object: TRequest): Promise<TResponse>;
  get<TResponse>(path: string): Promise<TResponse>;
}
